const employeePositions = [
  "Mecânico",
  "Eletricista",
  "Balconista",
  "Gerente de Oficina",
  "Gerente de Loja de Peças",
  "Gerente de Unidade",
];

export default employeePositions;